import { DetailColorId } from '@aboutyou/legacy-shared/src/utils/detailColor'
import { preferredColorsFilterOrder } from 'services/providers/bapi/entities/filters/constants'

export const sortColorsFilterComparator = (
  previousItem: ColorFilter,
  nextItem: ColorFilter,
): number => {
  const prevIndex = preferredColorsFilterOrder.indexOf(previousItem.value)
  const nextIndex = preferredColorsFilterOrder.indexOf(nextItem.value)

  if (prevIndex !== -1 && nextIndex === -1) {
    return -1
  }

  if (prevIndex === -1 && nextIndex !== -1) {
    return 1
  }

  if (prevIndex < nextIndex) {
    return -1
  }

  if (prevIndex > nextIndex) {
    return 1
  }

  return 0
}

export interface ColorFilter {
  id: string
  name: string
  value: DetailColorId
}
